/* Eps Changes — MLM auth popup logic (shared by cart page + cart drawer) */

(function () {
  "use strict";
// Eps new_flow changes start
  function getCurrentDomain() {
    return window.location.origin;
  }

  function getDistributorCookie() {
    var name = "distributor=";
    var decodedCookie = decodeURIComponent(document.cookie);
    var ca = decodedCookie.split(";");
    for (var i = 0; i < ca.length; i++) {
      var c = ca[i];
      while (c.charAt(0) == " ") {
        c = c.substring(1);
      }
      if (c.indexOf(name) == 0) {
        return c.substring(name.length, c.length);
      }
    }
    return "";
  }

  // distributor may live in the cookie (set by the SSO script) or in storage;
  // read every path so the note is carried even if one of them failed
  function getDistributorValue() {
    var value = getDistributorCookie();
    if (value) return value;
    try {
      value = sessionStorage.getItem("distributor") || "";
      if (value) return value;
      value = localStorage.getItem("distributor") || "";
    } catch (e) {
      // storage unavailable
    }
    return value || "";
  }

  // capture ?distributor=<code> into cookie + session storage as early as
  // possible so later steps (guest checkout) always have it, even when the
  // Django loadscript is slow or blocked
  function captureDistributorFromUrl() {
    var match = window.location.search.match(/[?&]distributor=([^&]+)/);
    if (!match) return;
    var code = decodeURIComponent(match[1]);
    if (!code) return;
    var expires = new Date();
    expires.setTime(expires.getTime() + 365 * 24 * 60 * 60 * 1000);
    document.cookie = "distributor=" + code + ";expires=" + expires.toUTCString() + ";path=/";
    try {
      sessionStorage.setItem("distributor", code);
    } catch (e) {
      // storage unavailable
    }
  }

  captureDistributorFromUrl();

  // ---- post-login redirect -----------------------------------------
  // A visitor who added a product and then logs in must land on the product
  // listing (/pages/produktauswahl) instead of the plain-login /cart fallback.
  // The cart state is captured the moment the login CTA is clicked (before the
  // cross-domain login round-trip) and applied synchronously on the page we
  // return to, before the loadscript's /cart redirect can win.
  var POST_LOGIN_REDIRECT_KEY = "mlm_post_login_redirect";
  var PRODUKTAUSWAHL_PATH = "/pages/produktauswahl";
  var POST_LOGIN_REDIRECT_TTL = 30 * 60 * 1000;

  function rememberPostLoginRedirect(target) {
    try {
      sessionStorage.setItem(
        POST_LOGIN_REDIRECT_KEY,
        JSON.stringify({ target: target, ts: Date.now() })
      );
    } catch (e) {
      // storage unavailable
    }
  }

  function clearPostLoginRedirect() {
    try {
      sessionStorage.removeItem(POST_LOGIN_REDIRECT_KEY);
    } catch (e) {
      // storage unavailable
    }
  }

  function readPostLoginRedirect() {
    try {
      var raw = sessionStorage.getItem(POST_LOGIN_REDIRECT_KEY);
      if (!raw) return "";
      var data = JSON.parse(raw);
      if (!data || !data.target) return "";
      if (Date.now() - (data.ts || 0) > POST_LOGIN_REDIRECT_TTL) {
        clearPostLoginRedirect();
        return "";
      }
      return data.target;
    } catch (e) {
      return "";
    }
  }

  // run on every page load: only acts on the page we return to after login,
  // and only when a product was in the cart. Drops mlm_register so the
  // loadscript's plain-login /cart fallback does not fire and race us.
  function applyPostLoginRedirect() {
    if (!isCustomer()) return;
    var target = readPostLoginRedirect();
    if (!target) return;
    clearPostLoginRedirect();
    try {
      sessionStorage.removeItem("mlm_register");
    } catch (e) {
      // storage unavailable
    }
    window.location.href = target;
  }

  // capture the cart state right before leaving for the MLM login so the
  // decision survives the (cross-domain) login round-trip
  function goToLogin(loginUrl) {
    var navigate = function () {
      window.location.href = loginUrl;
    };
    try {
      fetch("/cart.js")
        .then(function (response) { return response.json(); })
        .then(function (cart) {
          if (cart && cart.item_count > 0) {
            rememberPostLoginRedirect(PRODUKTAUSWAHL_PATH);
          } else {
            clearPostLoginRedirect();
          }
        })
        .catch(function () {})
        .then(navigate);
    } catch (e) {
      navigate();
    }
  }

  applyPostLoginRedirect();

  function getDistributorRole() {
    var name = "distributor_role=";
    var decodedCookie = decodeURIComponent(document.cookie);
    var ca = decodedCookie.split(";");
    for (var i = 0; i < ca.length; i++) {
      var c = ca[i];
      while (c.charAt(0) == " ") {
        c = c.substring(1);
      }
      if (c.indexOf(name) == 0) {
        return c.substring(name.length, c.length);
      }
    }
    return "";
  }

  function getDistributorLanding() {
    return getDistributorRole() === "af" ? "/pages/auswahl-kunde" : "/pages/start-auswahl";
  }

  function isCustomer() {
    return window.ShopifyCustomer?.isAuthenticated === true;
  }

  function isOnDistributorLandingPage() {
    var path = window.location.pathname.replace(/\/+$/, "");
    return (
      path === "/pages/start-auswahl" ||
      path === "/pages/auswahl-kunde" ||
      path === "/pages/produktauswahl"
    );
  }

  // set once the visitor explicitly chooses "Als Gast bestellen";
  // from then on the distributor gate must never bounce them again
  function isGuestFlow() {
    try {
      return sessionStorage.getItem("mlm_guest_checkout") === "1";
    } catch (e) {
      return false;
    }
  }
// Eps new_flow changes end
  function getMlmUrl() {
    var popup = document.getElementById("mlm-popup");
    return (popup && popup.dataset.mlmUrl) || "";
  }
// Eps new_flow changes start
  function openMlmPopup() {
    var distributor = getDistributorCookie();
    var isCust = isCustomer();
    // if (distributor !== "" && !isCust && !isGuestFlow()) {
    //   if (isOnDistributorLandingPage()) return;
    //   window.location.href = getCurrentDomain() + getDistributorLanding();
    // }    
  }
// Eps new_flow changes end

  function closeMlmPopup() {
    var popup = document.getElementById("mlm-popup");
    if (popup) popup.classList.remove("is-open");
  }

  // expose globally — used by inline onclick="" attributes and reload flow
  window.openMlmPopup = openMlmPopup;
  window.closeMlmPopup = closeMlmPopup;

  // build a URL that carries the distributor note (note=distributor:<code>)
  function withDistributorNote(baseUrl, note) {
    if (!note) return baseUrl;
    var separator = baseUrl.indexOf("?") === -1 ? "?" : "&";
    return baseUrl + separator + "note=" + encodeURIComponent("distributor:" + note);
  }

  // write the distributor note into the cart (best effort, non-blocking: never
  // let it delay the navigation, else a redirect can race ahead of it).
  // Uses the SSO helper when present, otherwise writes it from the theme so
  // the flow no longer depends on the Django loadscript.
  function writeDistributorCartNote() {
    var distributor = getDistributorValue();
    if (!distributor) return;

    try {
      if (typeof set_distributor_cart === "function") {
        Promise.resolve(set_distributor_cart()).catch(function () {});
        return;
      }
    } catch (e) {
      // SSO helper not available: fall through to the theme-side write
    }

    try {
      fetch("/cart/update.js", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ note: distributor })
      }).catch(function () {});
    } catch (e) {
      // ignore
    }
  }

  // guest checkout: remember the choice, carry note=distributor:<code> in the
  // URL immediately (read synchronously from the cookie) and write the cart
  // note in the background. The URL note must be set before we navigate.
  function proceedToGuestCheckout(baseUrl) {
    sessionStorage.setItem("mlm_guest_checkout", "1");
    var note = getDistributorValue();
    writeDistributorCartNote();
    window.location.href = withDistributorNote(baseUrl, note);
  }

  function goToGuestCheckout() {
    proceedToGuestCheckout("/checkout");
  }

// Eps new_flow changes start
  function reloadAndOpenPopup() {
    var distributor = getDistributorValue();
    var isCust = isCustomer();

    // both cases: the visitor explicitly chose "Als Gast bestellen" (guest flow)
    // OR is a referred visitor with the distributor in cookie/session.
    // Go straight to checkout carrying note=distributor:<code>, like the
    // previous flow.
    if (isGuestFlow() || (distributor !== "" && !isCust)) {
      goToGuestCheckout();
      return;
    }

    sessionStorage.setItem("openMlmPopup", "true");
    window.location.href = getCurrentDomain() + getDistributorLanding();
  }
// Eps new_flow changes end
  window.reloadAndOpenPopup = reloadAndOpenPopup;

  document.addEventListener("DOMContentLoaded", function () {
    if (sessionStorage.getItem("openMlmPopup") === "true") {
      sessionStorage.removeItem("openMlmPopup");
      openMlmPopup();
    }
// Eps new_flow changes start
var distributor = getDistributorCookie();
    var isCust = isCustomer();
    // if (distributor !== "" && !isCust && !isGuestFlow() && !isOnDistributorLandingPage()) {
    //   window.location.href = getCurrentDomain() + getDistributorLanding();
    // }
    // Eps new_flow changes end
    initCheckoutGate();
  });

  // close on backdrop click
  document.addEventListener("click", function (e) {
    if (e.target.id === "mlm-popup") {
      closeMlmPopup();
    }
  });

  // close on Escape
  document.addEventListener("keydown", function (e) {
    if (e.key === "Escape") closeMlmPopup();
  });

  document.addEventListener("click", function (e) {
    if (e.target.classList.contains("register-brand-partner")) {
      var variantId = e.target.dataset.variant;
      var mlmUrl = getMlmUrl();

      if (!variantId) {
        // nothing to add (no starter_kit product found) — just send to register
        sessionStorage.setItem("mlm_register", "true");
        window.location.href = e.target.dataset.url || (mlmUrl + "de/register");
        return;
      }

      fetch("/cart/add.js", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ id: variantId, quantity: 1 })
      })
        .then(function (response) { return response.json(); })
        .then(function () {
          sessionStorage.setItem("mlm_register", "true");
          window.location.href = mlmUrl + "de/register";
        })
        .catch(function () {
          // even if add-to-cart fails, don't trap the user in the popup
          sessionStorage.setItem("mlm_register", "true");
          window.location.href = mlmUrl + "de/register";
        });
    }
  });

  document.addEventListener("click", function (e) {
    if (e.target.classList.contains("mlm-redirect")) {
      var url = e.target.dataset.url;
      sessionStorage.setItem("mlm_register", "true");
      // plain login: remember whether a product sits in the cart so we can
      // land on the listing afterwards (registration links stay as before)
      if (e.target.dataset.type === "login") {
        goToLogin(url);
        return;
      }
      window.location.href = url;
    }
  });

  // start-auswahl "Anmelden" CTA — same post-login cart redirect as the popup
  document.addEventListener("click", function (e) {
    var link = e.target && e.target.closest ? e.target.closest('[data-et-start-target="login"]') : null;
    if (!link) return;
    e.preventDefault();
    goToLogin(link.getAttribute("href") || (getMlmUrl() + "de/login"));
  });

  // guest checkout button — popup ("ALS GAST FORTFAHREN") and the start-auswahl
  // "Als Gast bestellen" CTA (id set by the section). Capture phase so this runs
  // before (and suppresses) any other handler bound to the same button, and
  // because the click may land on the inner <span>.
  document.addEventListener("click", function (e) {
    var link = e.target && e.target.closest ? e.target.closest("#verify_checkout_guest") : null;
    if (!link) return;
    e.preventDefault();
    e.stopPropagation();
    proceedToGuestCheckout(link.getAttribute("href") || "/checkout");
  }, true);

  /* ------------------------------------------------------------------
     Checkout gate for Shopify's dynamic/accelerated checkout buttons
     (Shop Pay, PayPal, Google Pay, Apple Pay, etc.)

     These render as native Shopify web components inside
     `.additional-checkout-buttons` and bind their own click handlers
     internally — they can't be intercepted the same way as a plain
     <button onclick="">. Instead, while the user is an unresolved
     guest, a transparent gate div is placed on top to catch the click
     first and route it through the same popup flow as "Zur Kasse".
     Once resolved (or once the user is a logged-in customer), the
     gate is removed so real clicks reach the wallet buttons.
  ------------------------------------------------------------------ */

  function initCheckoutGate() {
    var containers = document.querySelectorAll(".additional-checkout-buttons");
    if (!containers.length) return;

    containers.forEach(function (container) {
      // guest already chose "order as guest": no gate, let the real buttons work
      if (isGuestFlow()) {
        container.classList.remove("mlm-gated");
        var existing = container.querySelector(".mlm-checkout-gate");
        if (existing) existing.remove();
        return;
      }
      // server already decided whether a gate is needed via data-mlm-gate
      if (container.dataset.mlmGate !== "true") return;
      if (container.querySelector(".mlm-checkout-gate")) return; // already gated

      container.classList.add("mlm-gated");

      var gate = document.createElement("div");
      gate.className = "mlm-checkout-gate";
      gate.setAttribute("role", "button");
      gate.setAttribute("aria-label", "Choose how to continue to checkout");
      container.appendChild(gate);

      gate.addEventListener("click", function (e) {
        e.preventDefault();
        e.stopPropagation();
        reloadAndOpenPopup();
      });
    });
  }

  // re-run if the cart updates the additional-checkout-buttons markup via ajax
  document.addEventListener("cart:updated", initCheckoutGate);
  document.addEventListener("cart:refresh", initCheckoutGate);
})();
